import { render, staticRenderFns } from "./DepartmentComponent.vue?vue&type=template&id=5e3ad2b3&scoped=true"
import script from "./DepartmentComponent.vue?vue&type=script&lang=js"
export * from "./DepartmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3ad2b3",
  null
  
)

export default component.exports